import React from 'react';
import { DashboardSidebar } from '@/layouts/dashboard';
import { Question, QuestionBody, QuestionHeader, QuestionMenu, QuestionMenuLink, QuestionMenuList, QuestionMenuTitle, QuestionTitle } from '@/components/custom/question';

export function ExamsQuestionsSidebar(props) {
  const { currentQuestion, setCurrentQuestion, taxonomies, exam, selectQuestionBookTaxonomy } = props;

  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <Question>
        <QuestionHeader>
          <QuestionTitle title={exam?.title}>{exam?.title}</QuestionTitle>
        </QuestionHeader>

        <QuestionBody>
          <QuestionMenu>
            {exam?.['question-book-taxonomies']?.map((qbTaxonomy, i) => {
              const taxonomy = taxonomies.find(taxonomy => taxonomy.id === qbTaxonomy.taxonomy_id);

              return (
                <div key={i}>
                  <QuestionMenuTitle>{taxonomy?.name}</QuestionMenuTitle>

                  <QuestionMenuList>
                    {qbTaxonomy.question_ids.map((questionId, j) => {
                      const index = j;

                      const isActive = currentQuestion === questionId;
                      const isDisabled = !!exam.taxonomies[i].answers.find(q => q.questionId === questionId);

                      const questionNumber = index < 9 ? `0${index + 1}` : `${index + 1}`;

                      return (
                        <QuestionMenuLink
                          key={questionId}
                          active={isActive}
                          disabled={isDisabled}
                          onClick={() => {
                            setCurrentQuestion(questionId);
                            selectQuestionBookTaxonomy(i);
                          }}
                        >
                          {questionNumber}
                        </QuestionMenuLink>
                      );
                    })}
                  </QuestionMenuList>
                </div>
              );
            })}
          </QuestionMenu>
        </QuestionBody>
      </Question>
    </DashboardSidebar>
  );
}
